<template>
	<v-row>
		<v-col cols="12" class="py-0">
			<div class="log-row py-0">
				<v-btn text plain class="text-capitalize pa-0 title-text" :color="color" @click="open_local = !open_local">
					Items
					<span v-if="items_local.length !== 0">&nbsp;({{ items_local.length }})</span>
					<v-icon v-if="!open_local" class="ml-2">mdi-chevron-down</v-icon>
					<v-icon v-if="open_local" class="ml-2">mdi-chevron-up</v-icon>
				</v-btn>
				<v-btn v-if="items_local.length === 0" text plain class="text-capitalize pa-0" @click="onAddItem()">
					<v-icon class="mr-2">mdi-plus</v-icon>
					Add Item
				</v-btn>
			</div>
		</v-col>
		<v-col v-if="items_local.length !== 0 && open_local" cols="12" class="py-0">
			<template v-if="items_local.length <= 1">
				<div v-for="item of items_local" :key="item.id" class="mb-5">
					<v-row class="ma-0">
						<v-col :cols="$vuetify.breakpoint.xsOnly ? 12 : 6" class="px-0" :class="$vuetify.breakpoint.xsOnly ? '': 'pt-0'">
							<KindTreeSelection
								:class="$vuetify.breakpoint.xsOnly ? '':'mr-3'"
								:color="color"
								:bgColor="bgColor"
								:kindParams="itemParams"
								:kindSelected="item.kind"
								:closeSelection="closeSelection"
								:isWidthAuto="true"
								:elementKey="`${item.id}`"
								@kind-selected="onKindChange($event, item.id)"
							/>
						</v-col>
						<v-col :cols="$vuetify.breakpoint.xsOnly ? 12 : 6" class="px-0" :class="$vuetify.breakpoint.xsOnly ? '': 'pt-0'">
							<v-row class="ma-0" align="center">
								<v-btn height="32" min-width="32" :color="item.units === 0 || item.units === '0' ? 'rgba(25, 42, 62, 0.15)': 'rgba(25, 42, 62, 0.45)'" class="px-0" :class="$vuetify.breakpoint.xsOnly ? '':'ml-3'" :disabled="item.kind === null || item.units === 0 || item.units === '0'" @click="onItemMinus(item.id)">
									<v-icon color="white">
										mdi-minus
									</v-icon>
								</v-btn>
								<v-text-field
									class="number mx-2"
									style="width: 80px"
									v-model="item.units"
									type="number"
									:error="(item.units === 0 || item.units === '0') && item.kind !== null"
									outlined
									hide-details
									dense
									hide-spin-buttons
									:color="color"
									:disabled="item.kind === null"
									min="0"
									oninput="if(this.value < 0) this.value = 0; if(this.value >= 0) this.value = Number.parseInt(this.value)"
								>
								</v-text-field>
								<v-btn height="32" min-width="32" :color="color" class="px-0" :disabled="item.kind === null" @click="onItemAddition(item.id)">
									<v-icon color="white">
										mdi-plus
									</v-icon>
								</v-btn>
							</v-row>
						</v-col>
					</v-row>
					<v-row class="ma-0">
						<v-col :cols="$vuetify.breakpoint.xsOnly ? 12 : 6" class="px-0" :class="$vuetify.breakpoint.xsOnly ? 'pt-0': 'pt-0'">
							<v-row class="ma-0">
								<v-select
									style="margin-top: 18px; width: 60px"
									v-model="item.currency"
									:items="currencies"
									item-text="code"
									item-value="id"
									outlined
									dense
									return-object
									:color="color"
									:background-color="bgColor"
									:item-color="color"
									hide-details
									@change="onCurrencyChange(item)"
								/>
								<div>
									<div class="optional-text mx-2">Rate</div>
									<v-text-field
										style="width: 70px"
										:value="item.charge_rate === 0 ? '0.00' : (item.charge_rate).toFixed(2)"
										:color="color"
										:background-color="bgColor"
										class="text-right mx-2"
										outlined
										dense
										hide-details
										:disabled="job && job.id !== 0 && job.overhead === true"
										min="0"
										oninput="if(this.value < 0) this.value = 0.00"
										@change="onChargeRate($event, item.id)"
									/>
								</div>
								<div :class="$vuetify.breakpoint.xsOnly ? '':'mr-3'">
									<div class="optional-text">Total</div>
									<v-text-field
										style="width: 70px"
										:value="item.charge_rate === 0 ? '0.00' : (item.charge_rate * item.units).toFixed(2)"
										:color="color"
										:background-color="bgColor"
										class="text-right"
										outlined
										dense
										hide-details
										disabled
									/>
								</div>
							</v-row>
						</v-col>
						<v-col :cols="$vuetify.breakpoint.xsOnly ? 12 : 6" class="px-0" :class="$vuetify.breakpoint.xsOnly ? '': 'pt-0'" align-self="end">
							<v-row class="ma-0">
								<v-textarea
									v-model="item.notes"
									:class="$vuetify.breakpoint.xsOnly ? '':'ml-3'"
									:color="color"
									:background-color="bgColor"
									placeholder="Enter a note"
									rows="1"
									outlined
									dense
									hide-details
								></v-textarea>
								<v-btn class="mt-1 ml-2" icon max-width="32" max-height="32" @click="onMinusItem(item.id)">
									<v-icon size="24">mdi-close</v-icon>
								</v-btn>
							</v-row>
						</v-col>
					</v-row>
				</div>
			</template>
			<template v-if="items_local.length > 1">
				<v-virtual-scroll
					:items="items_local"
					:item-height="$vuetify.breakpoint.xsOnly ? 282:142"
					:height="$vuetify.breakpoint.xsOnly ? 400: 220"
				>
					<template v-slot:default="{ item }">
						<div :key="item.id" class="mt-0 mb-5 mx-0">
							<v-row class="ma-0">
								<v-col :cols="$vuetify.breakpoint.xsOnly ? 12 : 6" class="px-0" :class="$vuetify.breakpoint.xsOnly ? '': 'pt-0'">
									<KindTreeSelection
										:class="$vuetify.breakpoint.xsOnly ? '':'mr-3'"
										:color="color"
										:bgColor="bgColor"
										:kindParams="itemParams"
										:kindSelected="item.kind"
										:closeSelection="closeSelection"
										:isWidthAuto="true"
										:elementKey="`${item.id}`"
										@kind-selected="onKindChange($event, item.id)"
									/>
								</v-col>
								<v-col :cols="$vuetify.breakpoint.xsOnly ? 12 : 6" class="px-0" :class="$vuetify.breakpoint.xsOnly ? '': 'pt-0'">
									<v-row class="ma-0" align="center">
										<v-btn height="32" min-width="32" :color="item.units === 0 || item.units === '0' ? 'rgba(25, 42, 62, 0.15)': 'rgba(25, 42, 62, 0.45)'" class="px-0" :class="$vuetify.breakpoint.xsOnly ? '':'ml-3'" :disabled="item.kind === null || item.units === 0 || item.units === '0'" @click="onItemMinus(item.id)">
											<v-icon color="white">
												mdi-minus
											</v-icon>
										</v-btn>
										<v-text-field
											class="number mx-2"
											style="width: 80px"
											v-model="item.units"
											type="number"
											:error="(item.units === 0 || item.units === '0') && item.kind !== null"
											outlined
											hide-details
											dense
											hide-spin-buttons
											:color="color"
											:disabled="item.kind === null"
											min="0"
											oninput="if(this.value < 0) this.value = 0; if(this.value >= 0) this.value = Number.parseInt(this.value)"
										>
										</v-text-field>
										<v-btn height="32" min-width="32" :color="color" class="px-0" :disabled="item.kind === null" @click="onItemAddition(item.id)">
											<v-icon color="white">
												mdi-plus
											</v-icon>
										</v-btn>
									</v-row>
								</v-col>
							</v-row>
							<v-row class="ma-0">
								<v-col :cols="$vuetify.breakpoint.xsOnly ? 12 : 6" class="px-0" :class="$vuetify.breakpoint.xsOnly ? 'pt-0': 'pt-0'">
									<v-row class="ma-0">
										<v-select
											style="margin-top: 18px; width: 60px"
											v-model="item.currency"
											:items="currencies"
											item-text="code"
											item-value="id"
											outlined
											dense
											return-object
											:color="color"
											:background-color="bgColor"
											:item-color="color"
											hide-details
											@change="onCurrencyChange(item)"
										/>
										<div>
											<div class="optional-text mx-2">Rate</div>
											<v-text-field
												style="width: 70px"
												:value="item.charge_rate === 0 ? '0.00' : (item.charge_rate).toFixed(2)"
												:color="color"
												:background-color="bgColor"
												class="text-right mx-2"
												outlined
												dense
												hide-details
												:disabled="job && job.id !== 0 && job.overhead === true"
												min="0"
												oninput="if(this.value < 0) this.value = 0.00"
												@change="onChargeRate($event, item.id)"
											/>
										</div>
										<div :class="$vuetify.breakpoint.xsOnly ? '':'mr-3'">
											<div class="optional-text">Total</div>
											<v-text-field
												style="width: 70px"
												:value="item.charge_rate === 0 ? '0.00' : (item.charge_rate * item.units).toFixed(2)"
												:color="color"
												:background-color="bgColor"
												class="text-right"
												outlined
												dense
												hide-details
												disabled
											/>
										</div>
									</v-row>
								</v-col>
								<v-col :cols="$vuetify.breakpoint.xsOnly ? 12 : 6" class="px-0" :class="$vuetify.breakpoint.xsOnly ? '': 'pt-0'" align-self="end">
									<v-row class="ma-0">
										<v-textarea
											v-model="item.notes"
											:class="$vuetify.breakpoint.xsOnly ? '':'ml-3'"
											:color="color"
											:background-color="bgColor"
											placeholder="Enter a note"
											rows="1"
											outlined
											dense
											hide-details
										></v-textarea>
										<v-btn class="mt-1 ml-2" icon max-width="32" max-height="32" @click="onMinusItem(item.id)">
											<v-icon size="24">mdi-close</v-icon>
										</v-btn>
									</v-row>
								</v-col>
							</v-row>
						</div>
					</template>
				</v-virtual-scroll>
			</template>
		</v-col>
		<v-col v-if="items_local.length !== 0 && open_local" cols="12" class="py-0">
			<v-btn v-if="items_local.length !== 0" text plain class="text-capitalize px-0" @click="onAddItem()" :disabled="editItem !== null && !isDuplication">
				<v-icon class="mr-2">mdi-plus</v-icon>
				Add another Item
			</v-btn>
		</v-col>
	</v-row>
</template>
<script>
import KindTreeSelection from "@/components/kinds/kind_tree_selection.vue"

export default {
	name: 'LogItem',
	props: {
		color: {
			type: String,
			default: '#81CC00'
		},
		currencies: {
			type: Array,
			default: () => []
		},
		showRates: {
			type: Boolean,
			default: true
		},
		open: {
			type: Boolean,
			default: false
		},
		items: {
			type: Array,
			default: () => []
		},
		job: {
			type: Object,
			default: null
		},
		phase: {
			type: Object,
			default: null
		},
		itemParams: {
			type: Object,
			default: () => {}
		},
		date: {
			type: String,
			default: ''
		},
		editItem: {
			type: Object,
			default: null
		},
		isDuplication: {
			type: Boolean,
			default: false
		},
		closeSelection: {
			type: Number,
			default: 0
		},
		bgColor: {
			type: String,
			default: '#FFFFFF'
		}
	},
	data() {
		return {
			error_msg: '',
			open_local: this.open,
			init_id: 0,

			items_local: this.items,
		}
	},
	components: {
		KindTreeSelection
	},
	watch: {
		items_local: {
			handler(val) {
				this.$emit('items-change', val)
			},
			deep: true
		},
		editItem() {
			if (this.editItem) {
				this.items_local = [];
				this.items_local.push(this.editItem);
			}
		},
		date(newVal) {
			if (this.editItem) {
				if (newVal !== this.editItem.date) {
					this.items_local.forEach(i => {
						const params = this._getChargeRateParams(i);
						this._getChargeRate(params, i.id);
					});
				}
			} else {
				this.items_local.forEach(i => {
					const params = this._getChargeRateParams(i);
					this._getChargeRate(params, i.id);
				});
			}
		},
		job() {
			if (this.editItem) {
				if (this.job && this.editItem.job_id !== this.job.id && this.job.id !== 0) {
					this.items_local.forEach(i => {
						i.currency = this.job ? this.job.currency : null;

						const params = this._getChargeRateParams(i);
						this._getChargeRate(params, i.id);
					});
				}
			} else {
				if (this.job && this.job.id !== 0) {
					this.items_local.forEach(i => {
						i.currency = this.job ? this.job.currency : null;

						const params = this._getChargeRateParams(i);
						this._getChargeRate(params, i.id);
					});
				}
			}
		},
		phase() {
			this.items_local.forEach(i => {		
				if (this.job && this.phase && i.kind) {
					this._checkKind(this.job.id, i.kind.id, this.phase.id)
						.then(val => {
							if (!val) {
								i.kind = null;
							}
						})
						.catch((reason) => {
							this.error_msg = reason;
						});
				}
			});
		},
		error_msg() {
			this.$emit('error-msg', this.error_msg);
		}
	},
	methods: {
		onAddItem() {
			if (!this.open_local) {
				this.open_local = true;
			}

			this.init_id += 1;

			const obj = {
				id: this.init_id,
				item_id: 0,
				units: 0,
				currency: this.job ? this.job.currency : null,
				charge_rate: 0,
				kind: null,
				notes: ''
			};
			this.items_local.push(obj);
		},
		onMinusItem(id) {
			this.items_local = this.items_local.filter(i => { return i.id !== id });

			if (this.items_local.length === 0) {
				this.open_local = false;
			}
		},
		onItemAddition(id) {
			this.items_local.forEach(i => {
				if (i.id === id) {
					const units = typeof(i.units) === 'string' ?  Number(i.units) : i.units;
					i.units = units + 1;
				}
			});
		},
		onItemMinus(id) {
			this.items_local.forEach(i => {
				if (i.id === id) {
					const units = typeof(i.units) === 'string' ? Number(i.units) : i.units;
					if (units > 0) {
						i.units = units - 1;
					}
				}
			});
		},
		onKindChange(kind_selected, index_id) {
			if (kind_selected) {
				this.items_local.forEach(i => {
					if (i.id === index_id) {
						i.kind = kind_selected;
						const params = this._getChargeRateParams(i);

						this._getChargeRate(params, index_id, kind_selected);
					}
				});
			} else {
				this.items_local.forEach(i => {
					if (i.id === index_id) {
						i.kind = null;
						i.units = 0;
					}
				});
			}
		},
		onCurrencyChange(item) {
			const params = this._getChargeRateParams(item);
			this._getChargeRate(params, item.id);
		},
		onChargeRate(rate, id) {
			this.items_local.forEach(i => {
				if (i.id === id) {
					i.charge_rate = Number.parseFloat(rate);
				}
			});
		},
		_getChargeRateParams(item) {
			const params = [];
			if (item.kind) {
				params.push('kind_id=' + item.kind.id);
			}

			if (item.currency) {
				params.push('currency_id=' + item.currency.id);
			}
			
			if (this.date && this.date.length !== 0) {
				params.push('date=' + this.date);
			}

			if (this.job) {
				params.push('job_id=' + this.job.id);
			}

			return params;
		},
		async _getChargeRate(params, item_id, kind_selected=null) {
			let url = "/api/config/rates/chargerate";
			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const {status, data, reason } = val.data;
					if (status == "OK") {
						this.items_local.forEach(i => {
							if (i.id === item_id) {
								if (kind_selected) {
									i.kind = kind_selected;
									i.units = 1;
								}
								i.charge_rate = data;
							}
						})
					} else {
						this.error_msg = reason;
					}
				})
				.catch(e => {
					this.error_msg = e.message;
				})
		},
		_checkKind(job_id, kind_id, phase_id) {
			let url = `/api/jobs/${job_id}/can_do_kind`;

			const params = [];
			params.push("kiid=" + kind_id);
			params.push("jpid=" + phase_id);


			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			return new Promise((resolve, reject) => {
				axios
					.get(url, {
						headers: {
							"Authorization": "Bearer " + this.$store.state.token,
							"Accept": "application/json"
						}
					})
					.then((val) => {
						const json = val.data;

						const { status, data, reason } = json;

						if (status == "OK") {
							if (data.can_do_client && data.can_do_jobtype) {
								resolve(true);
							} else {
								resolve(false);
							}
							
						} else {
							reject(reason);
						}
					})
					.catch((e) => {
						reject(e.message);
					});
			});	
		},
	}
}
</script>
<style lang="scss" scoped>
.log-row {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
}
.optional-text {
	font-family: Roboto;
	font-style: normal;
	font-weight: normal;
	font-size: 12px;
	color: #37495F;
}

::v-deep {
  .title-text .v-btn__content{
    opacity: 1 !important;
  }
	.number.v-text-field.v-text-field--enclosed .v-input__slot{
		padding-left: 4px;
		padding-right: 4px;
	}
}


</style>